import GeneralReportPage from "./general-report-page";

export default GeneralReportPage